import React from 'react';
import { Box } from '@mui/material';
import FlowThumbnail from './FlowThumbnail';

/**
 * Wraps {@link FlowThumbnail} in a small phone chrome (bezel + speaker notch) so a flow reads as
 * a device mock-up on the flows list. The screen aspect ratio is fixed at roughly 9:19.5 to match
 * a modern phone; the thumbnail renders the flow's first screen with the builder's component
 * registry, so no Meta call is needed.
 */
const FlowPhonePreview = ({ flowJson, width = 150, screenIndex = 0, variant = 'card' }) => {
  const screenWidth = width;
  const screenHeight = Math.round(width * 1.95);

  return (
    <Box
      sx={{
        flexShrink: 0,
        bgcolor: '#111418',
        borderRadius: `${Math.round(width * 0.16)}px`,
        p: '7px',
        pt: '11px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
      }}
    >
      {/* speaker / camera notch */}
      <Box
        sx={{
          width: 30,
          height: 4,
          mx: 'auto',
          mb: '6px',
          borderRadius: 2,
          bgcolor: 'rgba(255,255,255,0.35)',
        }}
      />
      <Box
        sx={{
          width: screenWidth,
          borderRadius: `${Math.round(width * 0.1)}px`,
          overflow: 'hidden',
          bgcolor: '#fff',
        }}
      >
        <FlowThumbnail flowJson={flowJson} screenIndex={screenIndex} height={screenHeight} variant={variant} />
      </Box>
    </Box>
  );
};

export default React.memo(FlowPhonePreview);
